/**
 * Calculate a jitter from given interval's min and max value.
 * @param {Number} min - the minimum time the jitter may be.
 * @param {Number} max - the maximum time the jitter may be.
 * @returns {Number} The given minimum + the calculated jitter in ms.
 */
export default function jitter(min, max) {
  return min + Math.floor(Math.random() * (max - min));
}
